import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import PremiumModal from './PremiumModal';

const Header: React.FC = () => {
  const location = useLocation();
  const [showPremiumModal, setShowPremiumModal] = useState(false);
    // Show "Go Premium" button on editor and privacy policy pages
  const showPremiumButton = location.pathname === '/editor' || location.pathname === '/privacy-policy';

  // Listen for global open event from banner clicks
  useEffect(() => {
    const handler = () => setShowPremiumModal(true);
    window.addEventListener('openPremiumModal', handler as EventListener);
    return () => window.removeEventListener('openPremiumModal', handler as EventListener);
  }, []);

  return (
    <>
      <header className="header">
        <div className="container header__container">
          <Link to="/" className="logo">
            <img src="/img/logo.svg" alt="DesignsTattoo" />
          </Link>

          {showPremiumButton && (
            <button 
              className="header__btn"
              onClick={() => setShowPremiumModal(true)}
            >
              <span>Go Premium</span>
            </button>
          )}
        </div>
      </header>

      {/* Premium Modal */}
      <PremiumModal 
        isOpen={showPremiumModal}
        onClose={() => setShowPremiumModal(false)}
      />
    </>
  );
};

export default Header;